import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { environment } from '../../environments/environment';
import { AppConfigService } from './app-config.service';

@Injectable({ providedIn: 'root' })
export class AppConfiguredGuard {
  constructor(private readonly appConfigService: AppConfigService,
    private readonly router: Router) {
  }

  canActivateChild(): boolean | UrlTree {
    return this.canActivate();
  }

  canActivate(): boolean | UrlTree {
    if (this.appConfigService.isConfigured()) {
      return true;
    }

    if (environment.runAsStandaloneApplication) {
      return this.router.parseUrl('admin-login');
    }

    return this.router.parseUrl('config-error');
  }
}
